<div class="content">
    <div class="content-header">
        <p>{{ 'pages.userRecords.card.requestDetailsDialog.userInfo' | translate }}</p>
        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
    </div>

    <div *ngIf="!loading">
        <div class="user-bcitiCard">
            <div class="cardType-block" [ngClass]="data.card.cardType">
                <span>
                    <i [ngClass]="cardIcon"></i>
                    {{ cardLabel }}
                </span>
            </div>
            <div class="user-infos">
                <div class="avatar-block">
                    <div class="avatar-wrapper" (click)="editMode && openPictureUpload()">
                        <img *ngIf="editMode ? editForm.get('picture').value : (data.card.renewal?.photo || data.card.photo)"
                            class="user-avatar"
                            [src]="editMode ? editForm.get('picture').value : (data.card.renewal?.photo || data.card.photo)"
                            alt="demo-avatar">
                        <div *ngIf="editMode ? !editForm.get('picture').value : !(data.card.renewal?.photo || data.card.photo)"
                            class="user-avatar user-avatar--placeholder">
                            <span class="icon-user-profile"></span>
                        </div>
                        <div *ngIf="editMode && !pictureUploader?.loading" class="avatar-edit-overlay">
                            <span class="icon-edit"></span>
                        </div>
                        <div *ngIf="editMode && pictureUploader?.loading" class="avatar-loading-overlay">
                            <mat-spinner diameter="24"></mat-spinner>
                        </div>
                        <a *ngIf="!editMode && userProfileLink"
                           [routerLink]="userProfileLink"
                           target="_blank"
                           class="profile-link"
                           (click)="$event.stopPropagation()">
                            <mat-icon>open_in_new</mat-icon>
                        </a>
                    </div>
                    <app-form-user-card-profile-picture
                        *ngIf="editMode"
                        #pictureUploader
                        class="avatar-hidden-uploader"
                        label=""
                        [familyUserId]="data.user.id"
                        [formControl]="editForm.get('picture')">
                    </app-form-user-card-profile-picture>

                    <span *ngIf="!editMode" class="user-name">
                        <span>
                            {{ data.card.renewal?.firstName || data.card.firstName }} {{ data.card.renewal?.lastName || data.card.lastName }}
                        </span>
                    </span>
                    <span *ngIf="editMode" class="user-name user-name--edit">
                        <app-form-input
                            class="edit-inline-input"
                            label="{{ 'pages.user-cards.update.firstName' | translate }}"
                            [formControl]="editForm.get('firstName')">
                        </app-form-input>
                        <app-form-input
                            class="edit-inline-input"
                            label="{{ 'pages.user-cards.update.lastName' | translate }}"
                            [formControl]="editForm.get('lastName')">
                        </app-form-input>
                    </span>
                </div>

                <div class="infos-block">
                    <p *ngIf="!editMode">
                        <span class="label">{{ 'common.fields.sex' | translate }}: </span>
                        <span *ngIf="!data.card.renewal?.sex">{{ 'common.' + (data.card.sex || data.user.sex) | translate }}</span>
                        <span *ngIf="data.card.renewal?.sex">{{ 'common.' + (data.card.renewal.sex || data.user.sex) | translate }}</span>
                    </p>
                    <app-user-card-select
                        *ngIf="editMode"
                        class="edit-inline-input"
                        [options]="sexOptions"
                        controlName="sex"
                        [form]="editForm"
                        label="{{ 'pages.user-cards.update.sex' | translate }}">
                    </app-user-card-select>

                    <p *ngIf="!editMode">
                        <span class="label">{{ 'common.fields.birthdate' | translate }}: </span>
                        <span *ngIf="!data.card.renewal?.birthDate">{{ formatDate(data.card.birthDate || data.user.birthDate) }}</span>
                        <span *ngIf="data.card.renewal?.birthDate">{{ formatDate(data.card.renewal.birthDate || data.user.birthDate) }}</span>
                    </p>
                    <!-- Birthdate: edit -->
                    <app-form-datepicker
                        *ngIf="editMode"
                        class="edit-inline-input edit-birthdate"
                        label="{{ 'pages.user-cards.update.birthdate' | translate }}"
                        [formControl]="editForm.get('birthDate')"
                        [max]="maxBirthDate">
                    </app-form-datepicker>

                    <!-- Address: view -->
                    <ng-container *ngIf="!editMode">
                        <p *ngIf="data.card.address || data.card.renewal?.address">
                            <span class="label">{{ 'common.fields.address-short' | translate }}: </span>
                            <span>
                                <span *ngIf="data.card.address?.unit || data.card.renewal?.address?.unit">
                                    {{ data.card.renewal?.address?.unit || data.card.address?.unit }}
                                </span>
                                {{ data.card.renewal?.address?.number || data.card.address?.number }}
                                {{ data.card.renewal?.address?.streetName || data.card.address?.streetName }},
                                {{ data.card.renewal?.address?.city || data.card.address?.city }},
                            </span>
                            <span>
                                {{ data.card.renewal?.address?.province || data.card.address?.province }},
                                {{ data.card.renewal?.address?.postCode || data.card.address?.postCode}}
                            </span>
                            <span *ngIf="selectedAddressSubType" class="address-verified-badge">
                                ✓ {{ 'pages.profile.addresses.verified' | translate }}
                            </span>
                        </p>
                        <p *ngIf="!(data.card.address || data.card.renewal?.address)" class="address-missing">
                            <span class="label">{{ 'common.fields.address-short' | translate }}: </span>
                            <span class="text-muted">-</span>
                        </p>
                    </ng-container>
                    <!-- Address: edit (address selector list) -->
                    <div class="address-selector" *ngIf="editMode && userAddresses.length > 0">
                        <span class="label">{{ 'common.fields.address-short' | translate }}:</span>
                        <div class="address-option"
                            *ngFor="let pa of userAddresses; let i = index"
                            [class.selected]="selectedAddressIndex === i"
                            (click)="selectAddress(i)">
                            <span class="address-radio">
                                <span class="radio-dot" [class.active]="selectedAddressIndex === i"></span>
                            </span>
                            <span class="address-option-text">
                                {{ pa.displayName }} &mdash;
                                {{ pa.address.unit ? '#' + pa.address.unit + ' ' : '' }}{{ pa.address.number }} {{ pa.address.streetName || pa.address.street }}, {{ pa.address.city }}
                            </span>
                            <span class="address-chips">
                                <span *ngIf="i === 0" class="address-chip address-chip--primary">
                                    {{ 'pages.profile.addresses.primaryResidence' | translate }}
                                </span>
                                <span *ngIf="pa.isVerified" class="address-chip address-chip--verified">
                                    {{ 'pages.profile.addresses.verified' | translate }}
                                </span>
                                <span *ngIf="!pa.isVerified" class="address-chip address-chip--unverified">
                                    {{ 'pages.profile.addresses.unverified' | translate }}
                                </span>
                            </span>
                            <button *ngIf="i !== 0"
                                class="address-delete-btn"
                                (click)="deleteAddress(pa); $event.stopPropagation()">
                                <span class="icon-trash-bin"></span>
                            </button>
                        </div>
                        <button class="address-add-btn" (click)="addNewAddress()">
                            + {{ 'pages.profile.addresses.addAddress' | translate }}
                        </button>
                    </div>
                    <app-form-geoid-address
                        *ngIf="editMode && userAddresses.length === 0"
                        class="edit-inline-input"
                        label="{{ 'pages.user-cards.update.address' | translate }}"
                        searchType="default"
                        [formControl]="editForm.get('address')">
                    </app-form-geoid-address>

                    <!-- Background check (always visible) -->
                    <p>
                        <span *ngIf="backgroundCheck?.backgroundCheck" class="backgroundCheck">
                            <span class="icon-warning"></span>
                            {{ 'pages.userRecords.card.requestDetailsDialog.backgroundCheck' | translate }}
                        </span>
                    </p>

                    <!-- SubType selector: only when address has no linked residence -->
                    <div *ngIf="subTypes?.length > 0 && !editMode && !selectedAddressSubType">
                        <form [formGroup]="requestCardForm">
                            <app-form-select
                                [options]="subTypes"
                                formControlName="subType"
                                [required]="true"
                                [invalid]="!requestCardForm?.valid && isSubmitted"
                                label="{{ 'pages.userRecords.card.requestDetailsDialog.subTypes.label' | translate }}"
                                [placeholder]="'pages.userRecords.card.requestDetailsDialog.subTypes.label' | translate">
                                <app-form-error *ngIf="!requestCardForm?.valid && isSubmitted">
                                    {{ 'pages.userRecords.card.requestDetailsDialog.message.approve.errorStatus' | translate }}
                                </app-form-error>
                            </app-form-select>
                        </form>
                    </div>
                    <!-- Forced subtype note: when address is residence-backed -->
                    <p *ngIf="subTypes?.length > 0 && !editMode && selectedAddressSubType" class="subtype-forced-info">
                        {{ 'pages.userRecords.card.requestDetailsDialog.subTypes.forced' | translate }}
                    </p>

                </div>
            </div>
        </div>

        <div class="files-header-row">
            <h4 class="files-header">{{ 'pages.userRecords.card.requestDetailsDialog.attachments' | translate }}</h4>
            <button *ngIf="approvalGuidelines" mat-icon-button class="approval-guide-btn" (click)="showApprovalGuide = !showApprovalGuide">
                <span class="icon-info"></span>
            </button>
            <div *ngIf="showApprovalGuide && approvalGuidelines" class="approval-guide-popover">
                <div class="approval-guide-header">
                    <span>{{ 'pages.userRecords.card.requestDetailsDialog.approvalGuide' | translate }}</span>
                    <button class="approval-guide-close" (click)="showApprovalGuide = false"><span class="icon-close"></span></button>
                </div>
                <div class="approval-guide-content ql-content-wrapper" [innerHTML]="approvalGuidelines"></div>
            </div>
        </div>

        <!-- View mode: read-only attachments -->
        <ng-container *ngIf="!editMode">
            <div class="files-container" *ngIf="data.card?.proofOfIdentity?.length > 0">
                <div *ngFor="let url of data.card.proofOfIdentity; let i = index"
                    class="file"
                    (click)="viewDocument(url)"
                    [ngStyle]="urlIsImage(url) ? {'background-image': 'url(' + url +')'} : ''"
                >
                    <span *ngIf="!urlIsImage(url)" class="pdf-file-icon icon-office-file-pdf"></span>
                </div>
            </div>
            <div class="files-container" *ngIf="data.card?.renewal?.proofOfIdentity?.length > 0 && data.action === CardActions.RENEW">
                <div *ngFor="let url of data.card.renewal.proofOfIdentity; let i = index"
                    class="file"
                    (click)="viewDocument(url)"
                    [ngStyle]="urlIsImage(url) ? {'background-image': 'url(' + url +')'} : ''"
                >
                    <span *ngIf="!urlIsImage(url)" class="pdf-file-icon icon-office-file-pdf"></span>
                </div>
            </div>
        </ng-container>

        <!-- Edit mode: editable attachments -->
        <div class="files-container" *ngIf="editMode">
            <div *ngFor="let url of activeAttachments; let i = index"
                class="file file--editable"
                (click)="viewDocument(url)"
                [ngStyle]="urlIsImage(url) ? {'background-image': 'url(' + url +')'} : ''"
            >
                <span *ngIf="!urlIsImage(url)" class="pdf-file-icon icon-office-file-pdf"></span>
                <button class="remove-attachment-btn" (click)="removeExistingAttachment(url); $event.stopPropagation()">
                    <span class="icon-close"></span>
                </button>
            </div>
            <div *ngFor="let file of newAttachmentFiles; let i = index"
                class="file file--editable"
                [ngStyle]="isNewFileImage(file) ? {'background-image': 'url(' + getNewFilePreview(file) +')'} : ''"
            >
                <span *ngIf="!isNewFileImage(file)" class="pdf-file-icon icon-office-file-pdf"></span>
                <button class="remove-attachment-btn" (click)="removeNewAttachment(i); $event.stopPropagation()">
                    <span class="icon-close"></span>
                </button>
            </div>
            <div class="file file--add" (click)="fileInput.click()">
                <span class="icon-plus"></span>
                <span class="add-label">{{ 'pages.userRecords.card.requestDetailsDialog.edit.addAttachments' | translate }}</span>
            </div>
            <input #fileInput type="file" accept="image/*,.pdf" multiple hidden (change)="onFileSelected($event)">
        </div>
    </div>
</div>

<!-- VERIFICATION SECTION -->
<div *ngIf="verification && !verificationLoading" class="verification-section">
    <h4 class="verification-title">{{ 'pages.userRecords.card.verification.title' | translate }}</h4>

    <!-- EXACT_MATCH -->
    <div *ngIf="verification.verificationType === 'EXACT_MATCH'" class="verification-card verification-card--success">
        <div class="verification-card__header">
            <mat-icon class="verification-card__icon">check_circle</mat-icon>
            <div>
                <h4 class="verification-card__title">{{ (data.action === CardActions.RENEW ? 'pages.userRecords.card.verification.exactMatchRenewal' : 'pages.userRecords.card.verification.exactMatch') | translate:{ cardNumber: verification.matches[0]?.number } }}</h4>
            </div>
        </div>
        <div class="verification-card__badge" *ngIf="verification.matches[0]?.number">
            <mat-icon>credit_card</mat-icon>
            <span>{{ verification.matches[0]?.number }}</span>
        </div>
    </div>

    <!-- DUPLICATE_BLOCKED -->
    <div *ngIf="verification.verificationType === 'DUPLICATE_BLOCKED'" class="verification-card verification-card--error">
        <div class="verification-card__header">
            <mat-icon class="verification-card__icon">block</mat-icon>
            <div>
                <h4 class="verification-card__title">{{ 'pages.userRecords.card.verification.duplicateBlocked' | translate:{
                    cardNumber: verification.matches[0]?.number,
                    email: verification.linkedToEmail
                } }}</h4>
            </div>
        </div>
    </div>

    <!-- PARTIAL_MATCH -->
    <div *ngIf="verification.verificationType === 'PARTIAL_MATCH'" class="verification-card verification-card--amber">
        <div class="verification-card__header">
            <mat-icon class="verification-card__icon">warning</mat-icon>
            <div>
                <h4 class="verification-card__title">{{ 'pages.userRecords.card.verification.partialMatch.title' | translate }}</h4>
                <p class="verification-card__body">{{ 'pages.userRecords.card.verification.partialMatch.message' | translate }}</p>
            </div>
        </div>

        <div class="verification-candidates">
            <mat-radio-group [(ngModel)]="selectedExternalId">
                <label
                    *ngFor="let match of verification.matches"
                    class="verification-candidate"
                    [class.verification-candidate--selected]="selectedExternalId === match.externalId"
                    (click)="selectedExternalId = match.externalId; selectedCardNumber = match.code || match.number">
                    <mat-radio-button [value]="match.externalId"></mat-radio-button>
                    <div class="verification-candidate__info">
                        <span class="verification-candidate__name">{{ match.firstName }} {{ match.lastName }}</span>
                        <span class="verification-candidate__dot">&middot;</span>
                        <span>{{ formatDate(match.birthDate) }}</span>
                        <span class="verification-candidate__dot">&middot;</span>
                        <span>{{ match.address?.streetName }}</span>
                    </div>
                    <span class="verification-candidate__card" *ngIf="match.number || match.code">{{ match.code || match.number }}</span>
                </label>

                <label
                    class="verification-candidate"
                    [class.verification-candidate--selected]="selectedExternalId === null"
                    (click)="selectedExternalId = null; selectedCardNumber = null">
                    <mat-radio-button [value]="null"></mat-radio-button>
                    <span class="verification-candidate__name">{{ 'pages.userRecords.card.verification.partialMatch.createNew' | translate }}</span>
                </label>
            </mat-radio-group>
        </div>
    </div>

    <!-- CARD_EXISTS_INFO_MISMATCH -->
    <div *ngIf="verification.verificationType === 'CARD_EXISTS_INFO_MISMATCH'" class="verification-card verification-card--amber">
        <div class="verification-card__header">
            <mat-icon class="verification-card__icon">warning</mat-icon>
            <div>
                <h4 class="verification-card__title">{{ 'pages.userRecords.card.verification.cardExistsMismatch.title' | translate }}</h4>
                <p class="verification-card__body">{{ 'pages.userRecords.card.verification.cardExistsMismatch.message' | translate }}</p>
            </div>
        </div>

        <div class="verification-candidates">
            <mat-radio-group [(ngModel)]="selectedExternalId">
                <label
                    *ngFor="let match of verification.matches"
                    class="verification-candidate"
                    [class.verification-candidate--selected]="selectedExternalId === match.externalId"
                    (click)="selectedExternalId = match.externalId; selectedCardNumber = match.code || match.number">
                    <mat-radio-button [value]="match.externalId"></mat-radio-button>
                    <div class="verification-candidate__info">
                        <span class="verification-candidate__name">{{ match.firstName }} {{ match.lastName }}</span>
                        <ng-container *ngIf="match.birthDate">
                            <span class="verification-candidate__dot">&middot;</span>
                            <span>{{ match.birthDate | date:'mediumDate':'UTC' }}</span>
                        </ng-container>
                        <span class="verification-candidate__dot">&middot;</span>
                        <span>{{ match.address?.streetName }}</span>
                    </div>
                    <span class="verification-candidate__card" *ngIf="match.number || match.code">{{ match.code || match.number }}</span>
                </label>
            </mat-radio-group>
        </div>
    </div>

    <!-- NO_MATCH -->
    <div *ngIf="verification.verificationType === 'NO_MATCH'" class="verification-card verification-card--info">
        <div class="verification-card__header">
            <mat-icon class="verification-card__icon">info</mat-icon>
            <div>
                <h4 class="verification-card__title">{{ 'pages.userRecords.card.verification.noMatch.title' | translate }}</h4>
                <p class="verification-card__body">{{ 'pages.userRecords.card.verification.noMatch.message' | translate }}</p>
            </div>
        </div>
    </div>
</div>

<!-- Loading state -->
<div *ngIf="verificationLoading && isCardConnected" class="verification-section">
    <h4 class="verification-title">{{ 'pages.userRecords.card.verification.title' | translate }}</h4>
    <div class="verification-loading">
        <mat-spinner diameter="24"></mat-spinner>
        <span>{{ 'pages.userRecords.card.verification.loading' | translate }}</span>
    </div>
</div>

<footer>
    <div *ngIf="!!discrepancies">
        <div class="row">
            <div class="col">
                <span class="icon-warning"></span>
            </div>
            <div class="text-warning">
                <span>{{ discrepancies.message}}</span>
            </div>
        </div>
        <mat-list>
            <mat-list-item *ngFor="let user of discrepancies.users">
                {{ user.firstName }} - {{ user.lastName }} - {{ user.cardNumber }}
            </mat-list-item>
        </mat-list>
    </div>
    <ng-container *ngIf="!loading && !editMode && canWriteCard">
        <button class="bciti-button bciti-button--lightblue-inversed" (click)="enterEditMode()">
            <span>{{ 'pages.userRecords.card.requestDetailsDialog.button.edit' | translate }}</span>
        </button>
        <button [disabled]="denyLoading || approveLoading" class="bciti-button bciti-button--red" (click)="handleDeny()">
            <span *ngIf="!denyLoading">{{ 'pages.userRecords.card.requestDetailsDialog.button.deny' | translate }}</span>
            <mat-spinner *ngIf="denyLoading" diameter="20"></mat-spinner>
        </button>
        <button [disabled]="approveLoading || denyLoading || isApprovalPressed || isApproveDisabled || isStatusRequired || verificationLoading" [attr.title]="isStatusRequired ? ('pages.userRecords.card.requestDetailsDialog.message.approve.errorStatus' | translate) : null" class="bciti-button bciti-button--blue"
        (click)="handleApprove()">
            <span
            *ngIf="!approveLoading">{{ 'pages.userRecords.card.requestDetailsDialog.button.approve' | translate }}</span>
            <mat-spinner *ngIf="approveLoading" diameter="20"></mat-spinner>
        </button>
    </ng-container>
    <ng-container *ngIf="editMode">
        <button class="bciti-button bciti-button--lightblue-inversed" (click)="cancelEdit()" [disabled]="editSaving">
            <span>{{ 'pages.userRecords.card.requestDetailsDialog.button.cancel' | translate }}</span>
        </button>
        <button class="bciti-button bciti-button--blue" (click)="saveEdit()"
            [disabled]="editForm?.invalid || editSaving">
            <span *ngIf="!editSaving">{{ 'pages.userRecords.card.requestDetailsDialog.button.save' | translate }}</span>
            <mat-spinner *ngIf="editSaving" diameter="20"></mat-spinner>
        </button>
    </ng-container>
</footer>
